export default {
	methods: {
		async saveTestPreview() {
			this.$emit("filterCard");
			this.$store.commit("testVUEX/setPreviewLoading", true);
			this.testDetails.activecard = !this.testDetails.activecard;
			let payload = {};
			if (this.testDetails.active || this.showPreviewTest) {
				payload = this.testDetails;
			}
			payload["topicName"] = this.selectedTopic.topicName;
			this.$store.commit("testVUEX/saveshowPreviewTest", {
				preview_status: this.showPreviewTest,
			});
			this.showTestConfig = false;
			this.$store.commit("testVUEX/saveShowTestConfig", {
				config_data: payload,
				config_status: this.showTestConfig,
			});
			await this.$store.dispatch(
				"sectionVUEX/getSection",
				this.testDetails.testID
			);
			this.$store.commit("testVUEX/setPreviewLoading", false);
			this.$forceUpdate();
		},
		saveTestConfig(data) {
			this.$emit("filterCard");
			let payload = {};
			payload = data;
			this.testDetails.activecard = !this.testDetails.activecard;
			this.showPreviewTest = false;
			if (!this.showTestConfig) {
				this.showTestConfig = true;
				this.$store.commit("testVUEX/saveShowTestConfig", {
					config_data: payload,
					config_status: this.showTestConfig,
				});
			} else if (payload.testID != this.testConfigData.testID) {
				this.$store.commit("testVUEX/saveShowTestConfig", {
					config_data: payload,
					config_status: this.showTestConfig,
				});
			} else {
				this.showTestConfig = !this.showTestConfig;
				this.$store.commit("testVUEX/saveShowTestConfig", {
					config_data: {
						testID: "",
					},
					config_status: this.showTestConfig,
				});
			}
			if (this.config_status) {
				this.config_status = false;
			}
			if (this.showTestConfig) {
				this.$store.commit("testVUEX/saveshowPreviewTest", {
					preview_status: false,
				});
			}
		},
		goToQPBuilder() {
			if (
				this.roles.includes("GET_QUESTION") &&
				this.roles.includes("GET_SECTION")
			) {
				this.$router.push({
					name: "QPBuilder",
					params: {
						testName: this.testDetails.name,
						testID: this.testDetails.testID,
						topicName: this.selectedTopic.topicName,
						topicID: this.$route.params.topicID,
					},
					query: {
						type: this.type,
						sort: this.sort,
						ttype: this.ttype,
						tsort: this.tsort,
					},
				});
			} else {
				this.errorToast("You don't have access to this page!");
			}
		},

		goToSharePage() {
			if (
				this.roles.includes("GET_TEST_INDIVIDUAL") ||
				this.roles.includes("GET_TEST_GROUP")
			) {
				this.$router.push({
					path: `/sharewithpeople/${this.$route.params.topicID}/${this.testDetails.testID}`,
					query: {
						type: this.type,
						sort: this.sort,
						ttype: this.ttype,
						tsort: this.tsort,
						testqp: "outside",
					},
				});
				this.$store.commit("testVUEX/saveSelectedTest", this.testDetails.name);
			}
		},
	},
};
